import { ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH } from '@runkr/schema'

/**
 * Private room code as typed or pasted: upper-cased, characters outside the code alphabet
 * dropped (no 0/O/1/I, spaces or dashes), at most `ROOM_CODE_LENGTH` long.
 */
export function filterCode(raw: string): string {
  let out = ''
  for (const ch of raw.toUpperCase()) {
    if (out.length === ROOM_CODE_LENGTH) break
    if (ROOM_CODE_ALPHABET.includes(ch)) out += ch
  }
  return out
}

/** True when `code` is a whole code (ready to join). */
export function isFullCode(code: string): boolean {
  return filterCode(code) === code && code.length === ROOM_CODE_LENGTH
}
